import GlobalVariables from '../GlobalVariables';
import { LogLevel } from '../enums/Enum';

const log = (text, level) => {
    if (!level) {
        level = ApexChat.currentLogLevel;
    }
    if (window.console) {
        if (level === LogLevel.Debug) {
            if (
                GlobalVariables.ApexChatDefaultLogLevel &&
                GlobalVariables.ApexChatDefaultLogLevel <= LogLevel.Debug
            ) {
                console.log(text);
            } else if (!GlobalVariables.ApexChatDefaultLogLevel) {
                console.log(text);
            }
        } else if (level === LogLevel.Warn) {
            if (
                GlobalVariables.ApexChatDefaultLogLevel &&
                GlobalVariables.ApexChatDefaultLogLevel <= LogLevel.Warn
            ) {
                console.warn(text);
            } else if (!GlobalVariables.ApexChatDefaultLogLevel) {
                console.warn(text);
            }
            console.warn(text);
        } else if (level === LogLevel.Error) {
            if (
                GlobalVariables.ApexChatDefaultLogLevel &&
                GlobalVariables.ApexChatDefaultLogLevel <= LogLevel.Warn
            ) {
                console.error(text);
            } else if (!GlobalVariables.ApexChatDefaultLogLevel) {
                console.error(text);
            }
        } else {
            console.log(text);
        }
    }
};
export default log;
